<!-- @format -->

<ng-container *transloco="let t">
  @if (courseUnitStateObject()?.isSubstituted || removedSubstitution()) {
    <sis-plan-structure-course-unit-substitutions
      [substitutedCourseUnit]="courseUnit()"
      [headingLevel]="headingLevel()"
      [showCompletionMethodSelection]="showCompletionMethodSelection()"
      [showAttainment]="showAttainment()"
      [removedSubstitution]="removedSubstitution()"
      [action]="action()"
      [selected]="selected()"
      [inputType]="inputType()"
      [actionInputId]="actionInputId()"
      [actionInputName]="actionInputName()"
      (actionChange)="actionChange.emit(courseUnit().id)"></sis-plan-structure-course-unit-substitutions>
  } @else {
    <sis-study-box
      data-cy="plan-structure-course-unit"
      [id]="courseUnit().id"
      [name]="courseUnit().name"
      [code]="courseUnit().code"
      [credits]="courseUnit().credits"
      [level]="headingLevel()"
      [studyState]="studyState()"
      [attainedCredits]="attainment()?.credits"
      [gradeId]="attainment()?.gradeId"
      [gradeScaleId]="attainment()?.gradeScaleId"
      [isSubstituted]="isSubstituted()"
      [isCrossStudyCourseUnit]="isCrossStudyCourseUnit()"
      [action]="action()"
      [selected]="selected()"
      [inputType]="inputType()"
      [actionInputId]="actionInputId()"
      [actionInputName]="actionInputName()"
      [nameClickable]="nameClickable()"
      (actionChange)="actionChange.emit($event)"
      (nameClickAction)="openCourseUnitInfoModal()">
      <ng-container study-box="notifications">
        <ng-content></ng-content>
        @if (invalidSelection()) {
          <sis-study-notification-box type="alert">{{ t("SIS_COMPONENTS.STUDY.INVALID_SELECTION") }}</sis-study-notification-box>
        }
        @if (courseUnitStateObject()?.moduleContentApproval === "DIFFERS_FROM_APPLIED") {
          <sis-study-notification-box type="alert">{{
            t("SIS_COMPONENTS.STUDY.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL")
          }}</sis-study-notification-box>
        }
        @if (courseUnitStateObject()?.moduleContentApproval === "DIFFERS_FROM_APPROVED") {
          <sis-study-notification-box type="alert">{{ t("SIS_COMPONENTS.STUDY.CONTENT_NOT_AS_APPROVED") }}</sis-study-notification-box>
        }
        @if (isAboutToExpire()) {
          <sis-study-notification-box type="info">{{
            t("SIS_COMPONENTS.STUDY.EXPIRATION_IMMINENT", { expiryDate: courseUnitStateObject().attainmentExpiryDate | localDateFormat })
          }}</sis-study-notification-box>
        }
        @if (newerVersionAvailable()) {
          <sis-study-notification-box type="info">{{
            t("SIS_COMPONENTS.PLAN.COURSE_UNIT.NEWER_VERSION_AVAILABLE")
          }}</sis-study-notification-box>
        }
        @if (attainment() && showAttainment()) {
          <sis-course-unit-attainment-box [courseUnit]="courseUnit()"></sis-course-unit-attainment-box>
        }
        @if (showCompletionMethodSelection() && (hasSelectableSubstitution$() | async)) {
          <sis-study-notification-box
            data-cy="plan-structure-select-substitution"
            type="substitution"
            [useFudisLink]="true"
            [tertiaryButtonText]="'SIS_COMPONENTS.STUDY.SELECT_SUBSTITUTION'"
            (tertiaryClickAction)="openSelectSubstitutionModal()">
            {{ t("SIS_COMPONENTS.STUDY.SUBSTITUTION_AVAILABLE") }}
          </sis-study-notification-box>
        }
        @if ((attainment()?.credits === null || attainment()?.credits === undefined) && showCompletionMethodSelection()) {
          <sis-completion-method-box
            [courseUnit]="courseUnit()"
            [courseUnitSelection]="getCourseUnitSelection(courseUnit().id)"></sis-completion-method-box>
        }
        @if (getCourseUnitSelection(courseUnit().id)?.gradeRaiseAttempt && showCompletionMethodSelection()) {
          <sis-course-unit-grade-raise-attempt-box
            [attainedCourseUnit]="courseUnit()"
            [gradeRaiseAttempt]="getCourseUnitSelection(courseUnit().id)?.gradeRaiseAttempt"></sis-course-unit-grade-raise-attempt-box>
        }
      </ng-container>
    </sis-study-box>
  }
</ng-container>
